export default {
  name: "TermsAndConditions",
  data: () => ({
    example: true
  })
};
